import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Capacitor } from '@capacitor/core';
import { MaterialModule } from 'src/app/material.module';
import { APP_STORE_URL, PLAY_STORE_URL } from 'src/app/core/constants/store-urls';

export interface AppUpdateDialogData {
  message: string;
}

@Component({
  selector: 'app-app-update-dialog',
  standalone: true,
  imports: [
    MaterialModule
  ],
  templateUrl: './app-update-dialog.component.html',
  styleUrls: ['./app-update-dialog.component.scss'],
})
export class AppUpdateDialogComponent {

  isNative = Capacitor.isNativePlatform();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppUpdateDialogData,
  ) { }

  // Deliberately does not close the dialog. Until the user actually updates, every
  // API call keeps coming back 426, so the block has to stay in place.
  update(): void {
    if (this.isNative) {
      // Native ships the web bundle inside the binary, so reloading changes nothing -
      // the only way forward is a new build from the store.
      window.open(Capacitor.getPlatform() == 'ios' ? APP_STORE_URL : PLAY_STORE_URL, '_blank');
    } else {
      window.location.reload();
    }
  }

}
